
import React from 'react';
import BankImportTable from '../components/BankImportTable';

const BankAccountsPage = () => (
  <BankImportTable />
);

export default BankAccountsPage;
